export default {
  name: 'go-contact',

  events: [
    {
      on: 'change',
      handle (e) {
        if (e.target.value !== '') {
          const label = e.target.options[e.target.selectedIndex].textContent
          // eslint-disable-next-line no-undef
          _paq.push(['trackEvent', 'Change', `banniere-contact-${label}`])
          window.location.href = `${this.props.contactUrl}?subject=${e.target.value}`
        }
      },
    },
  ],

  componentDidMount () {
  },
}
